<template>
  <div>
    <b-modal
      v-model="$store.state.showClipboard"
      button-size="sm"
      size="lg"
      centered
      title="Clipboard"
      hide-footer
      @close="closing"
      :modal-class="{ 'c-dark-theme': $store.state.darkMode }"
    >
      <d-table
        classdivtable="availtable datatable nested"
        refid="clipboard"
        :icon="'fa fa-paste'"
        :tools="''"
        :items="$store.state.clipboard"
        :pagesenabled="false"
      >
      </d-table>

      <b-row class="mt-2">
        <b-col>
          <b-button
            size="sm"
            variant="outline-primary"
            @click="$store.state.clipboard = null"
          >
            Empty Clipboard
          </b-button>
        </b-col>
      </b-row>

      <div class="form-actions text-right mt-4">
        <b-button
          squared
          size="sm"
          class="mr-2"
          v-if="currentStep > 1 && currentStep <= totalSteps"
          variant="secondary"
          @click="stepBack()"
          @keyup.enter="stepback()"
        >
          <i class="fa fa-arrow-left"></i> Prev
        </b-button>
        <b-button
          squared
          size="sm"
          v-if="currentStep < totalSteps"
          variant="primary"
          @click="stepNext()"
          @keyup.enter="stepNext()"
        >
          Next
          <i class="fa fa-arrow-right"></i>
        </b-button>

        <b-button
          squared
          size="sm"
          variant="secondary"
          class="ml-2 mr-2"
          @click="$store.state.showClipboard = false"
        >
           <i class="fa fa-chevron-left"></i> Back
        </b-button>
        <!-- {{currentStep}}
          {{totalSteps}}
          {{displayStep}}-->
      </div>
    </b-modal>
  </div>
</template>

<script>
export default {
  name: "b-clipboard",
  data() {
    return {
      columnnames: true,
      displayStep: 1,
      currentStep: 1,
      totalSteps: 1,
    };
  },
  methods: {
    closing() {
      this.$store.state.showClipboard = false;
    },
  },
};
</script>

<style>
</style>